import { Injectable, isDevMode } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as mixpanel from 'mixpanel-browser';

// models
import { MixpanelEvents } from '../models/mixpanelEvents';
import { ServiceFeatures } from '../models/serviceFeatures';

// services
import { SessionService } from './session.service';

type MixpanelInitParams = {
	$name: string;
	client: string;
	role: string;
	tariff: string;
	businessType?: string;
	storesCount?: number;
}

@Injectable({
	providedIn: 'root'
})
export class MixpanelService {

	private readonly _mixpanel: any; // need OverridedMixpanel type, but mixpanel have some error

	constructor(private sessionService: SessionService) {
		if (isDevMode()) return;
		if (SessionService.isStaff(this.sessionService.username)) return;
		if (!this.sessionService.clientId || !this.sessionService.defaults) return;
		if (this.sessionService.isFramePage) return;
        if (!this.sessionService.defaults.usageTrackingEnabled) return;
        if (!mixpanel) return;

		this._mixpanel = mixpanel?.default ?? mixpanel;
		this._mixpanel.init(environment.mixPanelToken);
		this._mixpanel.identify(this.sessionService.username);

		const initParams: MixpanelInitParams = {
			$name: this.sessionService.username,
			client: this.sessionService.clientName,
			role: this.sessionService.defaults.role.role_type.name,
			tariff: this.sessionService.defaults.tariff_plan.name
		};

		if (this.sessionService.hasFeature(ServiceFeatures.Demo)) {
			initParams.businessType = this.sessionService.defaults.demo.business_type;
			initParams.storesCount = this.sessionService.defaults.demo.stores_count;
		}
		this._mixpanel.people.set(initParams);
	}

	trackPage(event: MixpanelEvents, params: Object = {}): void {
		if (!this._mixpanel) return;
		Object.assign(params, {
			distinct_id: this.sessionService.username,
			tariff: this.sessionService.defaults.tariff_plan.name
		});
		try {
			this._mixpanel.track(event, params || {});
		} catch (error) {
			console.log(error);
		}
	}
}
